export default __webpack_public_path__ + "static/media/idetep.1366fa34.gif";